import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-phil-input',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './phil-input.component.html',
  styleUrl: './phil-input.component.scss',
})
export class PhilInputComponent {
  @Input() control!: FormControl;
  @Input() errorMessage!: string;
  @Input() placeholder!: string;
  @Input() pattern?: number;
  @Input() clearOnInvalid: boolean = false;
  @Output() onKeyDown = new EventEmitter<KeyboardEvent>();
  @Input() attributes!: any;
  @Input() type: string = 'text';
  isError = false;
  patternList: { [key: number]: RegExp } = {
    0: /[0-9]/,
    1: /^[a-zA-Z0-9@,-\s]+$/,
    2: /[a-zA-Z]/,
  };
  allowedKeys: string[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];

  ngOnInit() {
    if (this.clearOnInvalid) {
      this.control.valueChanges.subscribe(() => {
        if (this.control.invalid) {
          this.control.reset();
        }
      });
    }
  }

  onkeyDownEvent(event: KeyboardEvent) {
    const input = event.key;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (
      this.pattern !== undefined &&
      this.patternList[this.pattern] &&
      !this.patternList[this.pattern].test(input)
    ) {
      event.preventDefault();
    }
    this.onKeyDown.emit(event);
  }

  checkValid() {
    this.isError = !this.control.valid;
  }
}
